import { Component } from "@angular/core";

@Component({
	selector: "jhm-terms-and-conditions",
	imports: [],
	templateUrl: "./terms-and-conditions.component.html",
	styleUrl: "./terms-and-conditions.component.scss"
})
export class TermsAndConditionsComponent {

}
